import { render, staticRenderFns } from "./TrademarkOppositionBasisForOppositionForm.vue?vue&type=template&id=5792ad9b&"
import script from "./TrademarkOppositionBasisForOppositionForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionBasisForOppositionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports